import { Box, Grid, Stack, useElementBreakpoints } from "@compass/core";
import { BulkSelected, Select } from "components";
import { BulkSelectedItemErrors, Staff } from "generated/openApi";
import ApiService from "services/apiService";

export const SelectedStaffs = (props: {
  staffs: Map<number, Staff>;
  setStaffs: (value: Map<number, Staff>) => void;
  errors: BulkSelectedItemErrors[];
  setErrors: (value: BulkSelectedItemErrors[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, mediumFieldBreakpoints } = useElementBreakpoints();

  const getItemLabel = (staff: Staff) => (
    <Stack>
      {staff.lastName}, {staff.firstName}
    </Stack>
  );

  return (
    <Box ref={breakpointsRef}>
      <BulkSelected
        label="Staff"
        items={props.staffs || []}
        setItems={(value) => props.setStaffs(value)}
        getItemLabel={getItemLabel}
        errors={props.errors}
        setErrors={props.setErrors}
        quickAdd={
          <Grid container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
              <Select
                label={`Add Staff`}
                value={undefined as unknown as Staff}
                onChange={(e, value) => {
                  const newStaffs = new Map(props.staffs);
                  newStaffs.set(value.id, value);
                  props.setStaffs(newStaffs);
                }}
                fetchFunction={(searchString) => ApiService.search.staff(searchString)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionDisabled={(option) => props.staffs.has(option.id)}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {getItemLabel(option)}
                  </Box>
                )}
                getOptionLabel={() => ""}
              />
            </Grid>
          </Grid>
        }
      />
    </Box>
  );
};
